import { gql } from '@/core/shared/api';

export const getMonthlyStatements = async ({ dispatch, commit }) => {
  commit('setLoading', true);
  commit('setAdmin', {
    path: 'isFetchingAdmin',
    value: true,
  });

  const query = `{
    currentOrganization {
      id
      payoutThreshold
      invoices {
        id
        invoiceDate
        paidAt
        displayInvoiceTotal
        downloadLink
      }
    }
  }`;

  try {
    const { currentOrganization } = await gql.request(query);

    dispatch('insertEntities', {
      name: 'Organization',
      payload: currentOrganization,
    });

    return currentOrganization;
  } finally {
    commit('setLoading', false);
    commit('setAdmin', {
      path: 'isFetchingAdmin',
      value: false,
    });
  }
};

export const validateVatNumber = async ({ commit }, { organizationId, vatNumber }) => {
  commit('setLoading', true);

  const query = `{
    validateVatNumber(organizationId: "${organizationId}", vatNumber: "${vatNumber}")
  }`;

  try {
    return await gql.request(query);
  } finally {
    commit('setLoading', false);
  }
};

export async function getNetContentCreatorInvoices ({ dispatch, commit, getters }) {
  commit('setAdmin', { path: 'isFetchingAdmin', value: true });
  commit('setLoading', true);

  try {
    const { currentOrganization } = await gql.request(`{
      currentOrganization {
        id
        payoutThreshold
      }
    }`);
    dispatch('insertEntities', {
      name: 'Organization',
      payload: currentOrganization,
    });

    dispatch('getNetInvoices');
  } finally {
    commit('setLoading', false);
    commit('setAdmin', { path: 'isFetchingAdmin', value: false });
  }
}
